import React, { memo } from 'react'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import { Column } from '../../../../shared/types/Column'
import { StyledTableRow } from '../../../../shared/ui/StyledTableRow/StyledTableRow'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectPaginatedItems } from '../../model/selectors/selectPaginatedItems'
import { InstanceEventsCell } from './InstanceEventsCell'

interface InstanceEventsTableProps {
	columns: Column[]
}

export const InstanceEventsTable = memo(
	function InstanceEventsTable(props: InstanceEventsTableProps) {
		const { columns } = props
		const licenseEvents = useAppSelector(selectPaginatedItems)

		return (
			<TableBody>
				{licenseEvents.map((row, i) => (
					<StyledTableRow hover role="checkbox" tabIndex={-1} key={i}>
						{columns.map((column) => (
							<TableCell key={column.id} align={column.align}>
								<InstanceEventsCell
									columnId={column.id}
									value={row?.[column.id as keyof typeof row]}
								/>
							</TableCell>
						))}
					</StyledTableRow>
				))}
			</TableBody>
		)
	})
